export default function()
{
    const self = this;

    /**
     * The queued data to be placed in the session
     * @type {Object}
     */
    self.dataQueue = {};

    /**
     * The timeout that delays/limits the session calls
     * @type {Number|null}
     */
    self.settingTimeout = null;

    /**
     * The duration of the timeout that limits session calls
     * @type {Number}
     */
    self.settingTimeoutDuration = 1;

    /**
     * Set values in the session
     * @param {Object} values Values in key:value pairs
     * @param {String} identifier To give this call a name (optional)
     * @return Promise
     */
    self.set = (values, identifier = null) => {
        $.each(values, (key, value) => {
            self.dataQueue[key] = value;
        });

        // Start a new timeout, to limit the amount of calls
        clearTimeout(self.settingTimeout);
        self.settingTimeout = setTimeout(() => {
            $.post('/ajax/session/set', {
                identifier,
                values: self.dataQueue,
            }).then(() => {
                this.dataQueue = {};
            });
        }, self.settingTimeoutDuration);
    };

    /**
     * Get values from the session
     * @param {Array} keys Array of keys to get from the session
     * @param {String} identifier To give this call a name
     * @return Promise
     */
    self.get = (keys, identifier = null) => {
        return $.getJSON('/ajax/session/get', {
            identifier,
            keys,
        });
    };

    /**
     * Delete values from the session
     * @param {Array} keys Array of keys to delete from the session
     * @param {String} identifier To give this call a name
     * @return Promise
     */
    self.delete = (keys, identifier = null) => {
        return $.post('/ajax/session/delete', {
            identifier,
            keys,
        });
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/Session.js